var _ellipse, _path, _path2, _g, _circle, _ellipse2, _path3, _path4, _g2, _ellipse3, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJourneysIllus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.0396,
    cy: 37.2769,
    rx: 7.25832,
    ry: 2.41944,
    fill: "#C6377C",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36328 21.1158C4.36328 28.0869 10.7637 34.1994 14.0796 36.5386C17.1641 33.9938 23.7188 28.7038 23.7188 21.1158C23.7188 14.3298 18.0124 11.6309 14.0796 11.6309C10.1468 11.6309 4.36328 14.4069 4.36328 21.1158Z",
    fill: "#C6377C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7020_278796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 11,
    width: 20,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36328 21.1158C4.36328 28.0869 10.7637 34.1994 14.0796 36.5386C17.1641 33.9938 23.7188 28.7038 23.7188 21.1158C23.7188 14.3298 18.0124 11.6309 14.0796 11.6309C10.1468 11.6309 4.36328 14.4069 4.36328 21.1158Z",
    fill: "#EAE2FC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7020_278796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.04883 21.1158C2.04883 28.0869 8.44926 34.1994 11.7651 36.5386C14.8497 33.9938 21.4043 28.7038 21.4043 21.1158C21.4043 14.3298 15.6979 11.6309 11.7651 11.6309C7.83235 11.6309 2.04883 14.4069 2.04883 21.1158Z",
    fill: "#F260A7"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0023,
    cy: 21.2698,
    r: 3.62434,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.7669,
    cy: 23.4477,
    rx: 4.14579,
    ry: 1.95644,
    fill: "#C6377C",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9434 14.4571C31.9434 18.6681 35.8097 22.3605 37.8127 23.7735C39.676 22.2363 43.6354 19.0408 43.6354 14.4571C43.6354 10.3579 40.1884 8.72754 37.8127 8.72754C35.437 8.72754 31.9434 10.4045 31.9434 14.4571Z",
    fill: "#C6377C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7020_278796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 8,
    width: 13,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9434 14.4571C31.9434 18.6681 35.8097 22.3605 37.8127 23.7735C39.676 22.2363 43.6354 19.0408 43.6354 14.4571C43.6354 10.3579 40.1884 8.72754 37.8127 8.72754C35.437 8.72754 31.9434 10.4045 31.9434 14.4571Z",
    fill: "#EAE2FC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7020_278796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5439 14.4571C30.5439 18.6681 34.4102 22.3605 36.4133 23.7735C38.2765 22.2363 42.236 19.0408 42.236 14.4571C42.236 10.3579 38.7889 8.72754 36.4133 8.72754C34.0376 8.72754 30.5439 10.4045 30.5439 14.4571Z",
    fill: "#F260A7"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.7645,
    cy: 14.5507,
    rx: 2.18935,
    ry: 2.18935,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2334 36.793C25.7781 36.793 31.8038 36.793 34.6569 36.793C38.2232 36.793 39.4492 29.1718 34.2668 29.1718C31.9821 29.1718 33.5881 29.1717 29.966 29.1717C25.9539 29.1717 25.6753 23.2441 29.6317 23.2441H32.4063",
    stroke: "#C6377C",
    strokeWidth: 1.16133,
    strokeLinecap: "round",
    strokeDasharray: "1.16 3.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneysIllus);
export default __webpack_public_path__ + "static/media/journeys-illus.5695d35cb45dd0f0873e2946df99fce7.svg";
export { ForwardRef as ReactComponent };